/**
 * Deduplicate Google OAuth code exchange across StrictMode double-mounts.
 * Auth codes are single-use — a second POST fails and can race the first.
 */

type ExchangeResult = {
  success: true;
  isNewUser: boolean;
};

const inflight = new Map<string, Promise<ExchangeResult>>();

export function exchangeGoogleOAuthCodeOnce(
  code: string,
  exchange: (code: string) => Promise<ExchangeResult>,
): Promise<ExchangeResult> {
  const existing = inflight.get(code);
  if (existing) return existing;

  const promise = exchange(code).catch((error) => {
    // Allow a retry only after a hard failure (e.g. user refreshes with a new code).
    inflight.delete(code);
    throw error;
  });
  inflight.set(code, promise);
  return promise;
}
